import * as React from 'react';
import PropTypes from 'prop-types';
import favicon from './assets/lanl-favicon.png';
import defaultImage from './assets/default-share-image.jpeg';

const Seo = ({
  title,
  description,
  author,
  image,
  lang,
  keywords,
  children,
}) => {
  const seo = {
    title: title ?? 'Los Alamos National Laboratory',
    description: description ?? 'Explore everything Los Alamos is doing',
    author: author ?? 'Los Alamos National Laboratory',
    creator: '@LosAlamosNatLab',
    image: image ?? defaultImage,
    lang: lang ?? 'en',
    keywords: keywords ?? '',
  };

  return (
    <>
      <title>{seo.title}</title>
      <link rel='icon' type='image/png' href={favicon} />
      <meta name='description' content={seo.description} />
      <meta name='author' content={seo.author} />
      <meta name='image' content={seo.image} />
      <meta name='keywords' content={seo.keywords} />
      <meta name='twitter:card' content='summary' />
      <meta name='twitter:title' content={seo.title} />
      <meta name='twitter:url' content={seo.url} />
      <meta name='twitter:description' content={seo.description} />
      <meta name='twitter:image' content={seo.image} />
      <meta name='twitter:creator' content={seo.creator} />
      <meta property='og:title' content={seo.title} />
      <meta property='og:site_name' content='Los Alamos National Laboratory' />
      <meta property='og:description' content={seo.description} />
      <meta property='og:image' content={seo.image} />
      <meta property='og:type' content='website' />
      {children}
    </>
  );
};

Seo.propTypes = {
  author: PropTypes.string,
  children: PropTypes.node,
  description: PropTypes.string,
  image: PropTypes.string,
  keywords: PropTypes.string,
  lang: PropTypes.string,
  title: PropTypes.string,
};

export default Seo;
